var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5026 92.1666C27.4901 92.1666 8.83594 73.5124 8.83594 50.4999C8.83594 27.4874 27.4901 8.83325 50.5026 8.83325C73.5151 8.83325 92.1693 27.4874 92.1693 50.4999C92.1693 73.5124 73.5151 92.1666 50.5026 92.1666ZM50.5026 42.1666C49.3975 42.1666 48.3377 42.6056 47.5563 43.387C46.7749 44.1684 46.3359 45.2282 46.3359 46.3333V67.1666C46.3359 68.2717 46.7749 69.3315 47.5563 70.1129C48.3377 70.8943 49.3975 71.3333 50.5026 71.3333C51.6077 71.3333 52.6675 70.8943 53.4489 70.1129C54.2303 69.3315 54.6693 68.2717 54.6693 67.1666V46.3333C54.6693 45.2282 54.2303 44.1684 53.4489 43.387C52.6675 42.6056 51.6077 42.1666 50.5026 42.1666ZM50.5026 37.9999C51.6077 37.9999 52.6675 37.5609 53.4489 36.7795C54.2303 35.9981 54.6693 34.9383 54.6693 33.8333C54.6693 32.7282 54.2303 31.6684 53.4489 30.887C52.6675 30.1056 51.6077 29.6666 50.5026 29.6666C49.3975 29.6666 48.3377 30.1056 47.5563 30.887C46.7749 31.6684 46.3359 32.7282 46.3359 33.8333C46.3359 34.9383 46.7749 35.9981 47.5563 36.7795C48.3377 37.5609 49.3975 37.9999 50.5026 37.9999Z",
    fill: "url(#paint0_linear_3010_1305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3010_1305",
    x1: 8.8958,
    y1: 50.4999,
    x2: 92.2291,
    y2: 50.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.12ccafb15245afb3c02dc81be6063bea.svg";
export { ForwardRef as ReactComponent };